import { render, staticRenderFns } from "./NewMessageOverlay.vue?vue&type=template&id=0f59e74f&"
import script from "./NewMessageOverlay.vue?vue&type=script&lang=js&"
export * from "./NewMessageOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports